export default __webpack_public_path__ + "static/media/hero.9d2e86e5.webp";